import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Menu } from "@mui/material";
import { useState } from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import { IServiceHours } from "@/interfaces/service-hours.interface";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

type Props = {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ConfigurationTabMessages;
  selected: IServiceHours;
  onRemove: (item: IServiceHours) => void;
  onEdit: (item: IServiceHours) => void;
};

function ServiceHoursPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selected,
  onRemove,
  onEdit,
}: Props) {
  const [isDialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Menu
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <NotificationItem
          icon={<EditIcon />}
          title={messages.serviceHoursEditPopover}
          onClick={() => {
            onEdit(selected);
            onClose();
          }}
        />
        <NotificationItem
          icon={<DeleteIcon />}
          title={messages.serviceHoursDeletePopover}
          onClick={() => setDialogOpen(true)}
        />
      </Menu>

      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={() => {
          onRemove(selected);
          setDialogOpen(false);
          onClose();
        }}
        titleText={messages.serviceHoursDeleteDialogTitle}
        descriptionText={messages.serviceHoursDeleteDialogContent}
        cancelText={messages.serviceHoursCancelButton}
        confirmText={messages.serviceHoursDeletePopover}
        isLoading={false}
      />
    </>
  );
}

export default ServiceHoursPopover;
